export default __webpack_public_path__ + "static/1877-de81d4a04ad79a486824925de1be1a84.gif";